import EmblaCarousel from 'embla-carousel';
import { addPrevNextBtnsClickHandlers } from '../helpers/emblaControls';
const cartDrawerRecommendations = () => {
    const selectors = {
        cartDrawerRecommendationsCarousel: '[data-cart-drawer-recommendations-carousel]',
        cartDrawerRecommendationsCarouselViewport: '[data-cart-drawer-recommendations-carousel-viewport]',
        cartDrawerRecommendationsCarouselPrev: '[data-cart-drawer-recommendations-carousel-prev]',
        cartDrawerRecommendationsCarouselNext: '[data-cart-drawer-recommendations-carousel-next]',
        recommendation: '[data-recommendation]',
        recommendationSelect: '[data-recommendation-select]',
        recommendationImage: '[data-recommendation-image]',
        recommendationPrice: '[data-recommendation-price]',
        recommendationIndex: 'data-recommendation-index',
        variantID: 'data-variant-id',
        variantTitle: 'data-variant-title',
        variantImage: 'data-variant-image',
        variantPrice: 'data-variant-price',
        variantPriceWithoutCurrency: 'data-variant-price-without-currency',
        variantSKU: 'data-variant-sku',
        defaultImage: 'data-default-image',
        addToCart: '[data-recommendation-add-to-cart]',
        dynamicRecommendationsContainer: '[data-cart-drawer-dynamic-recommendations]',
    };
    const classes = {
        recommendationLoading: 'product-recommendation--loading',
    };
    const dynamicRecommendations = async () => {
        const dynamicRecommendationsContainer = document.querySelector(selectors.dynamicRecommendationsContainer);
        if (!dynamicRecommendationsContainer) {
            return;
        }
        const recommendationsSection = dynamicRecommendationsContainer.closest('.drawer__recommendations--auto');
        try {
            const response = await fetch('/cart.js');
            const data = await response.json();
            if (data.items.length) {
                // Cart has items - show recommendations
                if (recommendationsSection) {
                    recommendationsSection.classList.remove('cart-empty');
                }
                // Filter out donation items from recommendations
                const eligibleItems = data.items.filter((item) => {
                    const titleLower = item.title?.toLowerCase() || '';
                    return !titleLower.includes('donation');
                });
                // Get Most Recent Item from eligible items
                let mostRecentItemID = eligibleItems[0]?.product_id;
                const prioritizeGroup = dynamicRecommendationsContainer.getAttribute('data-group-prioritize');
                if (prioritizeGroup) {
                    const matchedItem = eligibleItems.find((item) => item.product_type === prioritizeGroup);
                    if (matchedItem) {
                        mostRecentItemID = matchedItem.product_id;
                    }
                }
                if (mostRecentItemID) {
                    // Get Section with Recommendations
                    const recommendationsResponse = await fetch(`${window.Shopify.routes.root}recommendations/products?product_id=${mostRecentItemID}&limit=10&section_id=cart-drawer-dynamic-recommendations&intent=related`);
                    const text = await recommendationsResponse.text();
                    const textHTML = new DOMParser().parseFromString(text, 'text/html');
                    const innerDivs = Array.from(textHTML.querySelectorAll('.product-recommendation'));
                    // Check if we have any recommendations
                    if (innerDivs.length === 0) {
                        // No recommendations found - hide the section
                        if (recommendationsSection) {
                            recommendationsSection.classList.add('cart-empty');
                        }
                        return;
                    }
                    const sortBy = dynamicRecommendationsContainer.getAttribute('data-sort');
                    const prioritizeMonogram = dynamicRecommendationsContainer.getAttribute('data-monogram-prioritize');
                    // Sort By
                    if (sortBy === 'price') {
                        innerDivs.sort((a, b) => {
                            const priceAEl = a.querySelector('.product-recommendation__add-to-cart__price');
                            const priceBEl = b.querySelector('.product-recommendation__add-to-cart__price');
                            const priceA = Number(priceAEl.getAttribute('data-price'));
                            const priceB = Number(priceBEl.getAttribute('data-price'));
                            return priceA - priceB;
                        });
                    }
                    // Non-monogram Prioritize
                    if (prioritizeMonogram == 'true') {
                        innerDivs.sort((a, b) => {
                            const isAMonogram = a.getAttribute('data-recommendation-monogram') === 'true';
                            const isBMonogram = b.getAttribute('data-recommendation-monogram') === 'true';
                            if (isAMonogram === isBMonogram)
                                return 0;
                            return isAMonogram ? 1 : -1;
                        });
                    }
                    let recommendationsHTML = '';
                    innerDivs.forEach((div) => {
                        recommendationsHTML += div.outerHTML;
                    });
                    dynamicRecommendationsContainer.innerHTML = recommendationsHTML;
                }
                else {
                    // No eligible product ID - hide recommendations
                    if (recommendationsSection) {
                        recommendationsSection.classList.add('cart-empty');
                    }
                }
            }
            else {
                // Cart is Empty - hide recommendations
                if (recommendationsSection) {
                    recommendationsSection.classList.add('cart-empty');
                }
            }
        }
        catch (err) {
            console.error(err);
        }
    };
    const recommendedProductsCarousel = () => {
        const recommendationsCarousel = document.querySelector(selectors.cartDrawerRecommendationsCarousel);
        if (recommendationsCarousel) {
            const viewportNode = recommendationsCarousel.querySelector(selectors.cartDrawerRecommendationsCarouselViewport);
            const prevButtonNode = recommendationsCarousel.querySelector(selectors.cartDrawerRecommendationsCarouselPrev);
            const nextButtonNode = recommendationsCarousel.querySelector(selectors.cartDrawerRecommendationsCarouselNext);
            const options = {
                loop: false,
                align: 'start',
                skipSnaps: true,
            };
            const embla = EmblaCarousel(viewportNode, options);
            const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(embla, prevButtonNode, nextButtonNode);
            const recommendations = recommendationsCarousel.querySelectorAll(selectors.recommendation);
            if (recommendations) {
                recommendations.forEach((recommendation) => {
                    const selector = recommendation.querySelector(selectors.recommendationSelect);
                    const imageContainer = recommendation.querySelector(selectors.recommendationImage);
                    const priceContainer = recommendation.querySelector(selectors.recommendationPrice);
                    const addToCart = recommendation.querySelector(selectors.addToCart);
                    if (selector) {
                        selector.addEventListener('change', () => {
                            const variantID = selector.selectedOptions[0].getAttribute(selectors.variantID);
                            const variantPrice = selector.selectedOptions[0].getAttribute(selectors.variantPrice);
                            const variantImage = selector.selectedOptions[0].getAttribute(selectors.variantImage);
                            if (variantImage != '') {
                                imageContainer.querySelector('img').src = variantImage;
                            }
                            else {
                                const defaultImage = selector.selectedOptions[0].getAttribute(selectors.defaultImage);
                                imageContainer.querySelector('img').src = defaultImage;
                            }
                            priceContainer.innerHTML = variantPrice;
                            addToCart.setAttribute('data-variant', variantID);
                        });
                    }
                    if (addToCart) {
                        addToCart.addEventListener('click', () => {
                            recommendation.classList.add(classes.recommendationLoading);
                            const variant = addToCart.getAttribute('data-variant');
                            const quickAddData = {
                                id: variant,
                                quantity: 1,
                            };
                            fetch('/cart.js', {})
                                .then((response) => {
                                return response.json();
                            })
                                .then((response) => {
                                const currency = response.currency;
                                const items_subtotal_price = response.items_subtotal_price;
                                fetch('/cart/add.js', {
                                    body: JSON.stringify(quickAddData),
                                    credentials: 'same-origin',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Requested-With': 'xmlhttprequest',
                                    },
                                    method: 'POST',
                                })
                                    .then(() => {
                                    // Data Layers
                                    window.dataLayer.push({ ecommerce: null });
                                    const index = recommendation.getAttribute(selectors.recommendationIndex);
                                    const itemName = recommendation.querySelector('.details__title').innerHTML;
                                    const itemVariant = selector?.selectedOptions?.[0]?.getAttribute(selectors.variantTitle);
                                    const itemPrice = selector?.selectedOptions?.[0]?.getAttribute(selectors.variantPriceWithoutCurrency);
                                    const itemSKU = selector?.selectedOptions?.[0]?.getAttribute(selectors.variantSKU);
                                    window.dataLayer.push({
                                        event: 'add_to_cart',
                                        ecommerce: {
                                            currency: currency,
                                            value: items_subtotal_price,
                                            items: [
                                                {
                                                    item_id: itemSKU,
                                                    item_name: itemName,
                                                    item_variant: itemVariant,
                                                    price: itemPrice,
                                                    quantity: 1,
                                                    index: index,
                                                    item_list_id: 'cart-drawer-recommendations',
                                                    item_list_name: 'Cart Drawer Recommendations',
                                                },
                                            ],
                                        },
                                    });
                                    // Data Layers -- End
                                    window.dispatchEvent(new CustomEvent('frank-green:quick-add-update', {}));
                                })
                                    .catch((err) => {
                                    console.error(err);
                                });
                            });
                        });
                    }
                });
            }
        }
    };
    const prepareRecommendationsAndCarousel = async () => {
        await dynamicRecommendations();
        recommendedProductsCarousel();
    };
    prepareRecommendationsAndCarousel();
    window.addEventListener('frank-green:cart-reloaded', () => {
        prepareRecommendationsAndCarousel();
    });
};
export { cartDrawerRecommendations };
